import { Clear } from '@mui/icons-material';
import { Autocomplete, Box, Button, Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import FormatCurrencyInput from '../../components/FormatNumber/FormatCurrencyInput';
import FormatNumberInput from '../../components/FormatNumber/FormatNumberInput';
import { typingTimeOut } from '../../constants';
import { InvoiceStatus } from '../../enums/invoiceStatus';

export interface FilterInvoicesForm {
  invoiceNumber?: string;
  projectId?: string;
  projectTitle?: string;
  status?: string[];
  total?: string;
}

interface Props {
  handleFormSubmit: (data: FilterInvoicesForm) => void;
  filterData: FilterInvoicesForm;
}

const defaultValues: FilterInvoicesForm = {
  invoiceNumber: '',
  projectId: '',
  projectTitle: '',
  status: [],
  total: ''
};

const FilterInvoices = (props: Props): JSX.Element => {
  const [filterData, setFilterData] = useState<FilterInvoicesForm>(
    props.filterData
  );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      props.handleFormSubmit(filterData);
    }, typingTimeOut);

    return () => clearTimeout(timeoutId);
  }, [filterData]);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFilterData((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value
    }));
  };

  const onClear = () => {
    setFilterData(defaultValues);
  };

  return (
    <form>
      <Grid container>
        <Grid item xs={11}>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <TextField
              sx={{ maxWidth: 245 }}
              label="Invoice #"
              name="invoiceNumber"
              value={filterData.invoiceNumber}
              onChange={handleChange}
              InputProps={{
                // eslint-disable-next-line
                inputComponent: FormatNumberInput as any
              }}
            />
            <TextField
              sx={{ maxWidth: 245 }}
              label="Project #"
              name="projectId"
              value={filterData.projectId}
              onChange={handleChange}
              InputProps={{
                // eslint-disable-next-line
                inputComponent: FormatNumberInput as any
              }}
            />
            <TextField
              sx={{ maxWidth: 245 }}
              label="Project Title"
              name="projectTitle"
              value={filterData.projectTitle}
              onChange={handleChange}
            />
            <TextField
              sx={{ maxWidth: 245 }}
              label="Total Invoice"
              name="total"
              value={filterData.total}
              onChange={handleChange}
              InputProps={{
                // eslint-disable-next-line
                inputComponent: FormatCurrencyInput as any
              }}
            />
            <Autocomplete
              multiple
              id="status"
              options={Object.keys(InvoiceStatus)}
              getOptionLabel={(option) => {
                const key = option as keyof typeof InvoiceStatus;
                return InvoiceStatus[key];
              }}
              value={filterData.status ?? []}
              onChange={(event, newValue) => {
                setFilterData((prevState) => ({
                  ...prevState,
                  status: newValue
                }));
              }}
              filterSelectedOptions
              sx={{ width: '100%', maxWidth: 245 }}
              renderInput={(params) => <TextField {...params} label="Status" />}
            />
          </Box>
        </Grid>
        <Grid item xs={1}>
          <Button
            variant="text"
            startIcon={<Clear />}
            onClick={() => onClear()}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default FilterInvoices;
